import React, { FC } from 'react'
import { Col, Row, useScreenClass } from 'react-grid-system'
import styled from 'styled-components'
import { Briefcase, Diagram3, Reception4 } from 'react-bootstrap-icons'

const Dotted = styled.hr<{ isDesktop: boolean }>`
  border: none;
  border-right: 2px dashed rgba(0, 0, 0, 0.12);
  background-color: transparent;
  height: ${(props) => (props.isDesktop ? '100%' : '98%')};
  width: 1px;
  position: absolute;
  top: ${(props) => (props.isDesktop ? '0' : '-10px')};
`
const Content = styled.div<{ isDesktop: boolean }>`
  max-width: 355px;
  margin-left: 1rem;
  margin-bottom: ${(props) => (props.isDesktop ? '' : '5rem')};
  h3 {
    margin-top: 0;
    font-size: var(--fs-heading-lg);
    color: ${(props) => props.theme.colors.black};
  }

  p {
    color: ${(props) => props.theme.colors.darkGray};
    line-height: 1.6rem;
  }
`

const Services: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  return (
    <>
      <Row justify="around" align="start" style={{ margin: '1.5rem 0 0.5rem' }}>
        <Col
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{
            maxWidth: isDesktop ? '480px' : '100%',
            position: 'relative',
          }}
        >
          <Dotted isDesktop={isDesktop} />
          <Content isDesktop={isDesktop}>
            <Reception4 color="#990000" size={36} />
            <h3>You Have a Great Idea But Can't Figure Out How to Make It Work</h3>
            <p>
              From concept to launch, you'll develop your podcast through hands-on focused assignments that cover what actually matters: defining your audience, sharpening your focus, and building sustainable production habits. Test your ideas and refine your approach within a curriculum designed around what works in podcasting.
            </p>
          </Content>
        </Col>
        <Col
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{
            maxWidth: isDesktop ? '480px' : '100%',
            position: 'relative',
          }}
        >
          <Dotted isDesktop={isDesktop} />
          <Content isDesktop={isDesktop}>
            <Diagram3 color="#990000" size={36} />
            <h3>You're Trying to Figure Everything Out Alone</h3>
            <p>
              Get direct instruction and personalized editorial feedback from working podcast and audio professionals, plus honest critiques and insider perspectives from guest speakers who are shaping the industry. More importantly, join a cohort that provides the kind of support and accountability that helps you stay motivated and moving forward.
            </p>
          </Content>
        </Col>
        <Col
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{
            maxWidth: isDesktop ? '480px' : '100%',
            position: 'relative',
          }}
        >
          <Dotted isDesktop={isDesktop} />
          <Content isDesktop={isDesktop}>
            <Briefcase color="#990000" size={36} />
            <h3>You Want to Create Something That Actually Finds Its Audience</h3>
            <p>
              Graduate with a polished, market-ready pilot—or multiple episodes—of your podcast, plus the production skills, marketing knowledge, and industry connections you need to succeed in this competitive field. This isn't just about making something; it's about making something that resonates with the people you want to reach.
            </p>
          </Content>
        </Col>
      </Row>
    </>
  )
}

export default Services
